"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable */
/* tslint:disable */
var React = require("react");
var Vimeo = function (_a) {
    var size = _a.size, props = __rest(_a, ["size"]);
    return (React.createElement("svg", __assign({ viewBox: "0 0 24 24", fill: "currentColor", width: size || "24", height: size || "24" }, props),
        React.createElement("path", { d: "M19.9922633,8.20803646 C19.9210628,9.76852654 18.8332158,11.9053403 16.7292022,14.6173579 C14.5538282,17.4503362 12.7133363,18.8666653 11.2077266,18.8666653 C10.2754005,18.8666653 9.48579544,18.0042597 8.84131127,16.2788086 C8.41058849,14.6971984 7.98034571,13.1157482 7.54978293,11.5341379 C7.07089984,9.8096468 6.55745652,8.94628122 6.00849297,8.94628122 C5.8888122,8.94628122 5.4699295,9.19860285 4.75280486,9.7013261 L4,8.72963983 C4.7896051,8.03443533 5.56865013,7.33939084 6.33505508,6.64338635 C7.38818189,5.73154046 8.17874699,5.25201736 8.7056304,5.20353705 C9.95091844,5.08369627 10.7173234,5.93650178 11.0050053,7.76211358 C11.3158873,9.7317263 11.5309286,10.9568542 11.6518894,11.4363773 C12.0107717,13.0704679 12.4056543,13.8864731 12.8371771,13.8864731 C13.1720593,13.8864731 13.6751025,13.3565497 14.3458268,12.2967029 C15.0159112,11.236536 15.3747935,10.4299708 15.4232738,9.87588723 C15.5186344,8.96100132 15.1595921,8.50243836 14.3458268,8.50243836 C13.9627844,8.50243836 13.5679018,8.59075893 13.1616592,8.76532006 C13.9479043,6.18466339 15.450314,4.93137529 17.6679283,5.00289575 C19.3119389,5.05121606 20.0869839,6.11954296 19.9922633,8.20803646", fillRule: "evenodd" })));
};
Vimeo.displayName = 'Vimeo';
exports.default = Vimeo;
/* tslint:enable */
/* eslint-enable */
//# sourceMappingURL=Vimeo.js.map